export const FALLBACK_IMAGE = '/ship.jpg';

export const FALLBACK_IMAGE_CONTENTFUL =
  'https://images.ctfassets.net/vmhwl5safgdj/6S43FFlyBY00enqGw14mqZ/ccbe8275902aa730f3d6829836c6cd77/ship.jpg';

export const MXP_BASE_URL =
  process.env.NEXT_PUBLIC_MXP_BASE_URL ?? 'https://anbord-tiles.meinschiff.com';

export const MXP365_API_BASE_URL =
  process.env.NEXT_PUBLIC_MXP365_API_BASE_URL ?? `${MXP_BASE_URL}/mxp365api`;

export const GET_SLASH_HOST = 'internet.meinschiff.de';
export const GET_SLASH_DOMAIN = `https://${GET_SLASH_HOST}`;

export const GET_SLASH_AUTH_URL =
  process.env.NEXT_PUBLIC_GET_SLASH_AUTH_URL ??
  'https://meinereisen.meinschiff.com/go/auth/get-slash';

export const ONBOARD_INTERNET_APP_DOMAIN = `https://internet.meinschiff.de`;

export const APP_URL_SCHEMA = 'meinschiff';
